import { render, staticRenderFns } from "./CustomerStockAccountList.vue?vue&type=template&id=3f4ee264&"
import script from "./CustomerStockAccountList.vue?vue&type=script&lang=js&"
export * from "./CustomerStockAccountList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports